import React from 'react';
import styled from 'styled-components';
import { device } from '../utils/devices';

const StyledFooter = styled.footer`
  background: ${props => props.theme.body}
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10vw;
  font-size: 18px;

  @media ${device.laptop} {
    flex-direction: row;
    padding: 4rem 6rem;
    justify-content: space-between;
  }

  h1 {
    font-size: 24px;
    font-weight: 200;

    @media ${device.laptop} {
      font-size: 48px;
    }
  }

  h2 {
    font-size: 16px;
    font-weight: 200;

    @media ${device.laptop} {
      font-size: 24px;
    }
  }

  a {
    color: white;
    text-decoration: none;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba(255,255,255,0.3);

    &:hover {
      opacity: .6;
    }
  }
`;

const Footer = (props) => {
  return (
    <StyledFooter>
      <h1>Contact</h1>
      <h2>Give us a ring! <a href='tel:1-917-371-7280'>(917) 371 7280</a></h2>
      <h2>For bookings & inquires, please <a href='mailto:studio@you-do-you.com'>email us</a></h2>
    </StyledFooter>
  )
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js